import { Link, Typography, useDeviceType } from '@braskai/ui-kit';

import { Chip, Stack } from '@mui/material';

import { HoverCard } from '@/shared/ui/HoverCard';

type DiscountChipProps = {
  label: string;
};

export const DiscountChip = ({ label }: DiscountChipProps) => {
  const { isMobile } = useDeviceType();

  // The "Most popular" flag reuses this chip's styling/position but without the promo tooltip.
  if (label === 'Most popular') {
    return (
      <Stack sx={{ position: 'absolute', right: isMobile ? 20 : 23, top: -13 }}>
        <Chip label={label} color="primary" size="small" />
      </Stack>
    );
  }

  return (
    <Stack sx={{ position: 'absolute', right: isMobile ? 20 : 23, top: -13 }}>
      <HoverCard
        content={
          <Stack alignItems="flex-start" flexDirection="column" paddingX={12} paddingY={8}>
            <Typography variant="body-2-md">Limited time offer</Typography>
            <Link
              href="https://www.rask.ai/promotion-november-18-2025"
              size="md"
              sx={{ cursor: 'pointer' }}
              target="_blank"
            >
              Learn more
            </Link>
          </Stack>
        }
        placement="bottom"
      >
        <Chip label={label} color="primary" size="small" />
      </HoverCard>
    </Stack>
  );
};
